/**
 * get EditClassGroup visibility
 * @param state
 * @returns {*|boolean}
 */

export const getEditClassGroupVisibility = state => (state.editClass.editClassGroupIsVisible);

/**
 * get Selected Group from Edit Class
 * @param state
 * @returns {*|null}
 */
export const getSelectedGroup = state => (state.editClass.selectedGroup);

/**
 * get selected group default status
 * @param state
 * @returns {*}
 */
export const getSelectedGroupIsDefault = state => (state.editClass.selectedGroup && state.editClass.selectedGroup.isDefault);

export const getIsLoadingEditClassDetail = state => (state.editClass.isLoadingEditClassDetail);

export const getClassroomDetail = state => (state.editClass.classroomDetail);

export const getIsDownloadingSignInCards = state => (state.editClass.isDownloadingSignInCards);

export const getIsSavingClass = state => (state.editClass.isSavingClass);

export const getDisableConfirmationButtons = state => (state.editClass.disableConfirmationButtons);



// WEBPACK FOOTER //
// ./app/containers/edit-class/selectors.js